import React from 'react';
import { useViewport } from '../../hooks/useViewport';
import { TwoColumnLayout } from '../../components/layouts';
import { SitePreview } from './SitePreview/SitePreview';
import { SideContent } from './SitePreview/SideContent';
import { MobileSitePreview } from './MobileSitePreview/MobileSitePreview';

export function SitePreviewWrapper() {
  const { isMobile } = useViewport();

  if (isMobile) {
    return <MobileSitePreview />;
  }

  return (
    <TwoColumnLayout
      mainContent={<SitePreview />}
      sideContent={<SideContent />}
      mainContentSpan={8}
      sideCellStyle={{ backgroundColor: '#FFFFFF' }}
    />
  );
}
